import { UseCase } from '@/domain/core/UseCase'
import { UserGeometry } from '@/domain/models/UserGeometry/UserGeometry'
import { Result } from '@/domain/protocols/Result'

import type { IUserGeometryRepository } from '@/data/UserGeometryRepository/IUserGeometryRepository'

// Persists metadata changes (e.g. rename): the repository marks unsynced, bumps
// updatedAt and emits UserGeometryChanged.
export class UpdateUserGeometryUseCase implements UseCase<UserGeometry, Promise<Result<void>>> {
  constructor(private readonly repository: IUserGeometryRepository) {}

  async execute(geometry: UserGeometry): Promise<Result<void>> {
    try {
      return await this.repository.updateGeometry(geometry)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
